import * as React from "react";
import Context from "./Context";
import "./Form.styl";
import DiscussionModel from "../models/DiscussionModel";

export default class Form extends React.Component<{
    model: DiscussionModel;
}> {

    private input: React.RefObject<HTMLTextAreaElement> = React.createRef();
    private timer: number = 0;

    public render(): React.ReactNode {
        const model = this.props.model;
        return (
            <Context.Consumer>
                {({dispatch, translate}) => (
                    <div className="Discussion-Form-Root" onClick={() => {
                        this.input.current.focus();
                    }}>
                        <div className="Discussion-Form-Body">
                            <div className="Discussion-Form-Text">{model.getFormValue()}</div>
                            <textarea
                                ref={this.input}
                                className="Discussion-Form-Input"
                                placeholder={translate("FORM_PLACEHOLDER")}
                                value={model.getFormValue()}
                                onChange={(event) => {
                                    dispatch("form/value", event.target.value);
                                }}
                            />
                        </div>
                        <div className="Discussion-Form-Foot">
                            <div className="Discussion-Form-Button" onClick={(event) => {
                                dispatch("form/submit");
                                event.stopPropagation();
                            }}>{translate("FORM_SUBMIT")}</div>
                        </div>
                    </div>
                )}
            </Context.Consumer>
        );
    }

    public componentDidUpdate(props: { model: DiscussionModel }): void {
        if (props.model.getDisplay() != this.props.model.getDisplay()) {
            if (this.props.model.getDisplay() && this.props.model.getTotal() == 0) {
                this.timer = window.setTimeout(() => {
                    this.timer = 0;
                    if (this.input.current  && this.props.model.getAutofocus()) {
                        this.input.current.focus();
                    }
                }, 250);
            } else {
                if (this.timer) {
                    window.clearTimeout(this.timer);
                    this.timer = 0;
                }
            }
        }
    }

}